import { Component, OnInit, Input, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service';
import { UserRoleService } from '../../services/user-role.service';

@Component({
    selector: 'app-assessment-plan',
    templateUrl: './assessment-plan.component.html',
    styleUrls: ['./assessment-plan.component.scss']
})
export class AssessmentPlanComponent implements OnInit {

    @Input('jobId') jobId;
    @Input('job') job;
    @Input('learnerId') learnerId;
    @Input('assessment') assessmentEdit;
    @Input('courseComponent') courseComponent;
    trackMaintenance: FormGroup;
    techCert: FormGroup;
    candidateSign: boolean;
    assessorSign: boolean;
    techCandidateSign: boolean;
    techAssessorSign: boolean;
    loading: boolean = false;
    trackMaintenanceEdit: any;
    techCertEdit: any;
    assessmentPlanEdit: any
    iscourseName
    componentList
    isEdit: boolean = false
    userRole = JSON.parse(localStorage.userRoles);
    jobData: any;
    isAdmin: boolean = false;
    isLearner: boolean = false;
    isIQA: boolean = false;
    isTrainer: boolean = false;
    constructor(
        public dialog: MatDialog,
        public _snackBar: MatSnackBar,
        public _learnerService: LearnerService,
        public cd: ChangeDetectorRef,
        public _userRoleService: UserRoleService
    ) { }

    ngOnInit() {
        if (!this.isEdit)
            this.createForm()
        // this.isCourseHide=true;  
    }

    ngOnChanges(changes: SimpleChanges) {
        console.log("changes in master rail AssessmentPlanComponent", changes);
        if (changes.learnerId && changes.learnerId.currentValue) {
            this.learnerId = changes.learnerId.currentValue
        }

        if (changes.jobId && changes.jobId.currentValue) {
            this.jobId = changes.jobId.currentValue
        }
        if(changes.job && changes.job.currentValue){
            this.jobData = changes.job.currentValue[0]
            this.getUserRole();
        }
        if (changes.courseComponent && changes.courseComponent.currentValue) {
            this.iscourseName = changes.courseComponent.currentValue
            console.log('this.......is coursename', this.iscourseName)

        }
        // else{
        //     this.isCourseHide=true;
        // }



        if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
            this.isEdit = true
            console.log("changes.assessmentEdit", changes.assessmentEdit.currentValue)
            this.assessmentPlanEdit = changes.assessmentEdit.currentValue
            console.log("assement plan edit data", this.assessmentPlanEdit);

            if (this.assessmentPlanEdit && this.assessmentPlanEdit.trackMaintenancePlan || this.assessmentPlanEdit.techCertPlan) {
                if (this.assessmentPlanEdit.trackMaintenancePlan && this.assessmentPlanEdit.trackMaintenancePlan.candidateSign != "") {
                    this.candidateSign = true
                }
                if (this.assessmentPlanEdit.trackMaintenancePlan && this.assessmentPlanEdit.trackMaintenancePlan.assessorSign != "") {
                    this.assessorSign = true
                }
                if (this.assessmentPlanEdit.techCertPlan && this.assessmentPlanEdit.techCertPlan.candidateSign != "") {
                    this.techCandidateSign = true
                }
                if (this.assessmentPlanEdit.techCertPlan && this.assessmentPlanEdit.techCertPlan.assessorSign != "") {
                    this.techAssessorSign = true
                }
            }

            this.createForm(this.assessmentPlanEdit)
        }
        else {
            this.createForm()

        }
        if (changes.courseComponent && changes.courseComponent.currentValue) {
            this.componentList = changes.courseComponent.currentValue
        }
    }
    getUserRole() {
        console.log("this......................", this.jobData);

        let getRole = this._userRoleService.getUserRole(this.jobData.instructors, 'job');
        if (getRole.isAdmin) this.isAdmin = true
        else if (getRole.isLearner) this.isLearner = true
        else if (getRole.isTrainer) this.isTrainer = true
        else if (getRole.isIQA) this.isIQA = true
    }
    createForm(details?) {
        console.log("details----> ", details)
        console.log("create form called, trackMaintenancePlan", this.trackMaintenanceEdit)
        console.log("create form called, trackMaintenancePlan", this.techCertEdit)
        this.techCert = new FormGroup({
            location: new FormControl((details && details.techCertPlan) ? details.techCertPlan.location : ''),
            date: new FormControl((details && details.techCertPlan) ? details.techCertPlan.date : ''),
            candidateSign: new FormControl((details && details.techCertPlan) ? details.techCertPlan.candidateSign : ''),
            assessorSign: new FormControl((details && details.techCertPlan) ? details.techCertPlan.assessorSign : '')
        })
        this.trackMaintenance = new FormGroup({
            location: new FormControl((details && details.trackMaintenancePlan) ? details.trackMaintenancePlan.location : ''),
            date: new FormControl((details && details.trackMaintenancePlan) ? details.trackMaintenancePlan.date : ''),
            candidateSign: new FormControl((details && details.trackMaintenancePlan) ? details.trackMaintenancePlan.candidateSign : ''),
            assessorSign: new FormControl((details && details.trackMaintenancePlan) ? details.trackMaintenancePlan.assessorSign : '')
        })
    }

    onChangeEvent(value, formGroup, formControl) {
        console.log("value, formControl, formGroup", value, formControl, formGroup);

        if (formGroup == 'trackMaintenance')
            this.trackMaintenance.get(formControl).setValue(value);

        else if (formGroup == 'techCert')
            this.techCert.get(formControl).setValue(value);

    }

    // Utility
    handleSnackBar(data) {
        this.openSnackBar(data.msg, data.button);
    }
    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 2000,
        });
    }

    openDialog(someComponent, data = {}): Observable<any> {
        console.log("OPENDIALOG", "DATA = ", data);
        const dialogRef = this.dialog.open(someComponent, {
            data, maxWidth: '100vw',
            maxHeight: '100vh',
            height: '100%',
            width: '100%'
        });
        return dialogRef.afterClosed();
    }


    checkLevel2Policy(policy) {
        let temp = this.componentList.includes(policy)
        if (temp) {
            return false
        } else {
            return true
        }
    }

    addSignature(formType, formControl) {
        if (this.isIQA) return
        else if (this.isLearner && formControl == 'assessorSign') return
        else if (this.isTrainer && formControl == 'candidateSign') return
        else {
            this.openDialog(SignaturePadComponent).subscribe((data) => {
                console.log("data of sign", data);
                if (data == undefined) return

                let sign = data

                if (formType == 'trackMaintenance') {
                    if (formControl == 'candidateSign') {
                        this.candidateSign = true
                        this.trackMaintenance.patchValue({
                            candidateSign: sign
                        })
                    }
                    if (formControl == 'assessorSign') {
                        this.assessorSign = true
                        this.trackMaintenance.patchValue({
                            assessorSign: sign
                        })
                    }
                } else if (formType == 'techCert') {
                    if (formControl == 'candidateSign') {
                        this.techCandidateSign = true
                        this.techCert.patchValue({
                            candidateSign: sign
                        })
                    }
                    if (formControl == 'assessorSign') {
                        this.techAssessorSign = true
                        this.techCert.patchValue({
                            assessorSign: sign
                        })
                    }
                }
            })
        }

    }





    saveForm() {
        console.log('save forms', this.trackMaintenance.value)
        console.log('save forms', this.techCert.value)
        this.loading = true
        //let data = {
        //    learnerId: this.learnerId,
        //    jobId: this.jobId
        //}
        //let details = {
        //    trackMaintenance: this.trackMaintenance.value,
        //    techCert: this.techCert.value,
        //}
        let data = {
            learnerId: this.learnerId,
            jobId: this.jobId,
            version: true,
            details: {
                trackMaintenancePlan: this.trackMaintenance.value,
                techCertPlan: this.techCert.value
            }
        }
        console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
        this._learnerService.submitPolicy(data).subscribe(res => {
            console.log('Policy res', res);
            this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
            this.loading = false
        }, (err) => {
            this.loading = false
            console.log("policy not accepted", err)
        })
    }
}
